import {
  DropDownList,
  DropDownListChangeEvent,
} from "@progress/kendo-react-dropdowns";
// import { promises } from "dns";
import React, { Fragment, useEffect, useState } from "react";
import ErrorMessage from "../Common/Components/ErrorMessage";
import Spinner from "../Common/Components/spinner";
import { useSelector } from "react-redux";
import { updateParams, getParamsSelector } from "../Common/Slices/ParamSlice";
import { NumericTextBox } from "@progress/kendo-react-inputs";
import { useAppDispatch } from "../Core/store.hooks";
import { TabStrip, TabStripTab } from "@progress/kendo-react-layout";
import { WarrantiesApi } from "./api";
import WarrantyGrid from "./WarrantyGrid";

interface WarrantiesWidgetProps {
  id: string;
  header: string;
}

const SearchGridWidget = (props: WarrantiesWidgetProps) => {
  const [warranties, updateWarranties] = useState(null);
  const [warrantiesLoading, updateLoadingWarranties] = useState(true);
  const [errorMessage, setErrorMessage] = useState(null);
  const globalParams = useSelector(getParamsSelector);

  useEffect(() => {
    if (globalParams.customerID != null) {
      updateLoadingWarranties(true);
      getWarranties(globalParams.customerID);
    }
  }, [globalParams.customerID]);

  const getWarranties = (cId) => {
    let params: any = { customerId: cId };
    WarrantiesApi.getCustomerWarranties(params)
      .then((response: any) => {
        console.log(response);
        updateWarranties(response);
        updateLoadingWarranties(false);

        setErrorMessage(null);
      })
      .catch((error) => {
        updateLoadingWarranties(true);
        setErrorMessage("Oops something went wrong, unable to get data.");

        console.log(error);
      });
  };

  if (warrantiesLoading) {
    return <Spinner text="warranties" />;
  }
  if (errorMessage != null) {
    return (
      <>
        <br />
        <ErrorMessage
          text={"No data found"}
          id={props.id}
          header={props.header}
        />
      </>
    );
  }
  return <WarrantyGrid data={warranties} />;
};

export default SearchGridWidget;
